module.exports = __webpack_public_path__ + "img/bg.de38241a.jpg";